import {applyMiddleware, combineReducers, compose, createStore, Reducer } from 'redux';
import thunk, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import projectsReducer, {ProjectsAction, ProjectsState} from "./data/projects";
import authReducer, {AuthAction, AuthState} from "./data/auth";
import {authUser} from "./data/auth/service";

type IncubatorAction = ProjectsAction | AuthAction;

// see : https://github.com/reduxjs/redux-thunk/blob/master/test/typescript.ts
export type ThunkResult<R> = ThunkAction<R, State, undefined, IncubatorAction>;

export type ThunkDispatchArg = ThunkDispatch<State, undefined, IncubatorAction>;


export interface State {
  projects: ProjectsState,
  auth: AuthState,
}

const reducers: Reducer<State, IncubatorAction> = combineReducers({
  projects: projectsReducer,
  auth: authReducer,
})


const enhancer = compose(applyMiddleware(thunk));
export const store = createStore(reducers, enhancer);
